import { FC, JSX } from "react";
import Divider from "@/app/components/Divider";
import { Text, View } from "react-native";
import { useCreateMonitoringCheckingMutation } from "@/_store/monitoringSubscription/monitoring.slice";
import StatsBlock, { IStatItem } from "@/app/components/StatsBlock";
import TextBanner from "@/app/components/TextBanner";
import CustomButton from "@/app/components/CustomButton";
import useErrorHandler from "@/_hooks/Toasters/useHandlerError";
import useCustomBottomSheet from "@/_hooks/useBottomSheet";
import { Router, useRouter } from "expo-router";

interface IResultSubscriptionCompany {
  title: string;
  statsInfo: IStatItem[];
  isLoading: boolean;
  inn: string;
}

const ResultSubscriptionCompany: FC<IResultSubscriptionCompany> = ({
  title,
  statsInfo,
  isLoading,
  inn,
}): JSX.Element => {
  const [createMonitoringChecking ] = useCreateMonitoringCheckingMutation();
  const { handleError } = useErrorHandler();
  const { closeSheet } = useCustomBottomSheet();
  const router: Router = useRouter();
  const handleSubmit = async (): Promise<void> => {
    if (!inn) return;

    try {
      await createMonitoringChecking({ inn }).unwrap();
      router.push("/(main)/subscriptionAnalytics");
      closeSheet();
    } catch (error: any) {
      handleError(error)
    }
  };

  return (
    <View>
      <Divider />
      <Text className="text-md text-black mb-5">
        {title}
      </Text>
      <StatsBlock stats={statsInfo} isLoading={isLoading} />
      <TextBanner />
      <CustomButton
        onPress={handleSubmit}
        title="Получать уведомления о проверках"
      />
    </View>
  );
};

export default ResultSubscriptionCompany;
